export default {
  /**
   * Object properties
   * id: Unique identifier,
   * message: Locale key | Actual text
   * [named]: Locale name formatting keys
   */
  items: [],
};
